<template>
  <div class="max-w-lg m-auto my-16">

    <BrokerpadLogo />

    <div class="p-8 bg-white mt-6 rounded shadow-lg border">

      <div class="text-2xl font-light text-gray-700">
        Please confirm your registration
      </div>

      <div class="mt-6 leading-normal text-base">
        We just sent an email to you with 
        a link to confirm your registration. 
        Please check your inbox.
      </div>
    </div>

    <div class="pl-8 mt-6">
      <PublicFooter />
    </div>
  </div>
</template>

<script>

  import PublicFooter   from "@/shared/components/public/Footer";
  import BrokerpadLogo  from '@/shared/components/BrokerpadLogo';

  export default {

    components : {
      PublicFooter,
      BrokerpadLogo
    },

    mounted() {
      document.body.className = 'bg-gray-100'
    },

    beforeDestroy() {
      document.body.className = ''
    },
  }
</script>